export default __webpack_public_path__ + "static/media/accounts.382d68b7.jpg";